import { useAtomValue, useUpdateAtom } from "jotai/utils"

import { atom } from "jotai"
import { useEffect } from "react"
import { useTypedLocalStorage } from "hooks/useLocalStorage"

const dgPreference = atom<boolean>(false)

export function useDGPreference() {
  const [stored, setStored] = useTypedLocalStorage<boolean>(
    "digital_calculator",
    false,
  )
  const value = useAtomValue(dgPreference)
  const update = useUpdateAtom(dgPreference)

  const toggle = () => {
    setStored(!stored)
  }

  useEffect(() => {
    update(stored)
  }, [stored, update])

  return { value, toggle }
}
